module.exports = __webpack_public_path__ + "static/media/03 REGGIANA CALCIO P Prampolini.b99aa574.svg";